import { format } from 'date-fns';
import { BAROMETER_AREAS } from 'constants/surveys';
import { type ChartDataPoint } from 'types/chart';
import type { BarometerAreaKey } from 'types/surveys';
import { formatUnifiedForDisplay } from 'utils/date';
import { type BarometerResponse } from './types';

export interface BarometerChartDataPoint extends ChartDataPoint {
  [BAROMETER_AREAS.EMOTIONAL]?: number;
  [BAROMETER_AREAS.PROFESSIONAL]?: number;
  [BAROMETER_AREAS.RELATIONAL]?: number;
  [BAROMETER_AREAS.HEALTH]?: number;
  [key: string]: unknown;
}

export const createDataPoint = (
  result: BarometerResponse,
  index: number
): BarometerChartDataPoint => {
  const completedAt = new Date(result.completedAt ?? Date.now());
  const completedAtStr = result.completedAt ?? new Date().toISOString();
  const maxSurveyScore = result.maxSurveyScore ?? 100;
  const totalScore = result.totalSurveyScore ?? 0;
  const scorePercentage = maxSurveyScore > 0 ? (totalScore / maxSurveyScore) * 100 : 0;

  const dataPoint: BarometerChartDataPoint = {
    week: index + 1,
    score: scorePercentage,
    label: `${formatUnifiedForDisplay(completedAtStr, 'dd/MM/yyyy')} (${index + 1})`,
    date: format(completedAt, 'yyyy-MM-dd'),
  };

  if (result.scorePerTag && result.maxScorePerTag) {
    const areaValues = Object.values(BAROMETER_AREAS) as BarometerAreaKey[];
    for (const [backendKey, score] of Object.entries(result.scorePerTag)) {
      if (areaValues.includes(backendKey as BarometerAreaKey)) {
        const maxScore = result.maxScorePerTag[backendKey] ?? 100;
        dataPoint[backendKey as BarometerAreaKey] = maxScore > 0 ? (score / maxScore) * 100 : 0;
      }
    }
  }

  return dataPoint;
};
